<script setup lang="ts">
import {Head, router, useForm} from "@inertiajs/vue3";
import Layout from "@/Pages/auth/layouts/AuthLayout.vue";
import TextField from "@/Pages/auth/components/TextField.vue";
import FormCard from "@/Pages/auth/components/FormCard.vue";
import SingleActionCard from "@/Pages/auth/components/SingleActionCard.vue";

interface Props {
    status?: string
}

defineOptions({layout: Layout})
defineProps<Props>()
const form = useForm({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
})

const submit = () => {
    form.post(route('register'), {
        onFinish: () => {
            form.reset('password', 'password_confirmation')
        },
    })
}

const login = () => {
    router.visit(route('login'))
}
</script>

<template>
    <Head title="Join SendCrypt" />
    <form-card
        :status="status"
        :loading="form.processing"
        :error-messages="form.errors.email || form.errors.name || form.errors.password || form.errors.password_confirmation"
        @submit="submit"
    >
        <template #title>
            Sign up to SendCrypt
        </template>
        <text-field
            v-model="form.name"
            label="Username"
            :required="true"
            type="text"
            :autofocus="true"
        />
        <text-field
            v-model="form.email"
            label="Email"
            type="email"
            :required="true"
        />
        <text-field
            v-model="form.password"
            label="Password"
            type="password"
            :required="true"
        />
        <text-field
            v-model="form.password_confirmation"
            label="Confirm password"
            type="password"
            details="Make sure it's at least 9 characters including a number and a uppercase letter."
            :required="true"
        />
        <template #submit>
            Create account
        </template>
        <template #hint>
            <div class="mt-3 text-caption">
                By creating an account, you agree to the <a
                    href="https://www.sib.swiss/privacy-policy"
                    target="_blank"
                >Terms of Service</a>. For more information about SIB's privacy
                practices, see the <a
                    href="https://www.sib.swiss/privacy-policy"
                    target="_blank"
                >SIB Privacy Policy</a>.
            </div>
        </template>
    </form-card>
    <single-action-card>
        <span class="mr-1">Already have an account?</span>
        <a
            class="cursor-pointer text-decoration-none text-blue-darken-3"
            @click="login"
        >Sign in</a>
    </single-action-card>
</template>

<style scoped>

</style>
